import { useCallback } from 'react';
import { PlusIcon } from '@i-ark/components';
import { resolveByPlatform } from '@i-ark/utils';
import { Button } from './atom.button.js';
import { jsx } from 'react/jsx-runtime';

function ZoomInTool(props) {
  const handleClick = useCallback(evt => {
    evt.preventDefault();
    props.zoomIn();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.zoomIn]);
  if (!props.zoomEnabled) {
    return null;
  }
  return /*#__PURE__*/jsx(Button, {
    tooltip: "Zoom ind",
    shortcut: resolveByPlatform({
      win: "Ctrl-+",
      mac: "Cmd-+"
    }),
    onClick: handleClick,
    disabled: !props.zoomInEnabled,
    children: /*#__PURE__*/jsx(PlusIcon, {
      size: 21
    })
  });
}

export { ZoomInTool };
//# sourceMappingURL=tool.zoom-in.js.map
